import { Controller } from "@hotwired/stimulus"

// Full text remains in the trigger's accessible name, even when visually clipped.
export default class extends Controller {
  static targets = ["trigger", "text", "popup"]

  connect() {
    this.resizeObserver = new ResizeObserver(() => this.hide())
    this.resizeObserver.observe(this.triggerTarget)
  }

  show() {
    if (!this.textTargets.some(text => text.scrollWidth > text.clientWidth)) return
    this.popupTarget.hidden = false
    const roomAbove = this.element.getBoundingClientRect().top
    const below = roomAbove < this.popupTarget.offsetHeight + 8
    this.popupTarget.style.top = below ? "100%" : "auto"
    this.popupTarget.style.bottom = below ? "auto" : "100%"
    this.triggerTarget.setAttribute("aria-expanded", "true")
  }

  focus() {
    if (this.triggerTarget.matches(":focus-visible")) this.show()
  }

  hide() {
    this.popupTarget.hidden = true
    this.triggerTarget.setAttribute("aria-expanded", "false")
  }

  outside(event) { if (!this.element.contains(event.target)) this.hide() }

  disconnect() {
    this.resizeObserver.disconnect()
    this.hide()
  }
}
